export default "__VITE_ASSET__DlVKV25E__"